export default class Reviews {
    constructor(element) {
        this.selector = element;

        this.initSlider();
    }

    async initSlider() {
        const target = this.selector.querySelector('[data-slider]');

        if (!target) {
            return;
        }

        const { default: Glide } = await import('@glidejs/glide');
        this.Glide = Glide;

        const slider = this.mountSlider();

        this.updateSliderBullets();
        this.updateSliderNavigation();

        this.slidePrev(slider);
        this.slideNext(slider);

        slider.on('run.after', () => {
            this.updateSliderActiveBullet(slider.index);
        });

        this.resizeSlider(slider);
    }

    mountSlider() {
        return new this.Glide(this.selector, {
            type: 'slider',
            perView: this.getSlidesPerView(),
            animationDuration: 300,
            rewindDuration: 300,
            animationTimingFunc: 'ease-in-out',
            gap: 24,
            rewind: true,
            bound: true,
        }).mount();
    }

    slidePrev(slider) {
        const button = this.selector.querySelector('[data-slider-button="prev"]');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            slider.go('<');
        });
    }

    slideNext(slider) {
        const button = this.selector.querySelector('[data-slider-button="next"]');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            slider.go('>');
        });
    }

    resizeSlider(slider) {
        let timeout;
        let prevWidth = window.innerWidth;

        window.addEventListener('resize', () => {
            const currentWidth = window.innerWidth;

            if (currentWidth === prevWidth) {
                return;
            }

            clearTimeout(timeout);
            timeout = setTimeout(() => {
                slider.update({ perView: this.getSlidesPerView(), startAt: 0 });
                this.updateSliderBullets();
                this.updateSliderNavigation();
                this.updateSliderActiveBullet(slider.index);
                prevWidth = currentWidth;
            }, 300);
        });
    }

    updateSliderBullets() {
        const items = this.selector.querySelectorAll('[data-slider-item]');
        const count = items.length - this.getSlidesPerView() + 1;
        const bullets = this.selector.querySelectorAll('[data-slider-bullet]');

        bullets.forEach((bullet, index) => {
            if (index < count) {
                bullet.classList.remove('hidden');
            } else {
                bullet.classList.add('hidden');
            }
        });
    }

    updateSliderNavigation() {
        const navigation = this.selector.querySelector('[data-slider-navigation]');
        const items = this.selector.querySelectorAll('[data-slider-item]');
        const count = items.length - this.getSlidesPerView();

        if (count > 0) {
            navigation.classList.remove('hidden');
        } else {
            navigation.classList.add('hidden');
        }
    }

    updateSliderActiveBullet(index) {
        const bullets = this.selector.querySelectorAll('[data-slider-bullet]:not(.hidden)');
        const activeBullet = this.selector.querySelector('[data-slider-bullet].active-slider-bullet');

        if (bullets.length === 0) {
            return;
        }

        activeBullet.classList.remove('active-slider-bullet');
        bullets[index].classList.add('active-slider-bullet');
    }

    getSlidesPerView() {
        if (window.innerWidth < 768) {
            return 1
        }

        if (window.innerWidth < 1024) {
            return 2;
        }

        return 3;
    }
}